export default __webpack_public_path__ + "static/char-thumb-40-e6c14bbc72201aafa3bec065368730b6.png";